$(document).ready(function(){

    // Global - Main Navigation
    $('.nav-trigger').click(function() {
        $('.nav-overlay').fadeIn(200);	
        $(this).fadeOut(200).addClass('active');
    });
    $('.nav-overlay').click(function(){
        $(this).fadeOut(300);
        $('.nav-trigger').fadeIn(300).removeClass('active');
    });	

});


// WEBPACK FOOTER //
// ./src/js/nav.js